'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.note_values = exports.MidiWriter = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.midi_init = midi_init;
exports.play_note = play_note;
exports.play_midi_note = play_midi_note;
exports.play_sequence = play_sequence;
exports.play_interval_sequence = play_interval_sequence;
exports.export_pattern_as_midi = export_pattern_as_midi;

var _tone = require('tone');

var _tone2 = _interopRequireDefault(_tone);

var _webmidi = require('webmidi');

var _webmidi2 = _interopRequireDefault(_webmidi);

var _scales = require('./scales');

var _scales2 = _interopRequireDefault(_scales);

var _util = require('./util');

var _kalimba = require('./kalimba');

var _kalimba2 = _interopRequireDefault(_kalimba);

var _FileSaver = require('file-saver/FileSaver');

var _ui = require('./ui');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var midiDevice = void 0;
var sendPitchBend = false;

var MidiWriter = exports.MidiWriter = require('midi-writer-js');

var note_values = exports.note_values = [[8, '8 measures', 8 * 512], [4, '4 measures', 4 * 512], [2, '2 measures', 2 * 512], [1, 'whole note', 512], [1 / 2, 'half note', 256], [1 / 3, 'third note', [170, 170, 171]], [1 / 4, 'quarter note', 128], [1 / 5, 'fifth note', [51, 51, 51, 51, 52]], [1 / 6, 'sixth note', [85, 85, 86, 85, 85, 86]], [1 / 8, 'eighth note', 64], [1 / 10, 'tenth note', [25, 26, 26, 25, 26, 25, 26, 26, 25, 26]], [1 / 12, 'twelfth note', [21, 21, 22, 21, 21, 22, 21, 21, 22, 21, 21, 22]], [1 / 16, 'sixteenth note', 32], [1 / 32, 'thirtysecond note', 16]];

function midi_init() {
  _webmidi2.default.enable(midi_ready);
  function midi_ready(err) {
    if (err) {
      console.error('webmidi failed to initialize');
      return;
    }
    if (!_webmidi2.default.outputs.length) {
      console.error('no MIDI output found');
      return;
    }
    console.log(_webmidi2.default.inputs);
    console.log(_webmidi2.default.outputs);
    if (_webmidi2.default.outputs.length > 1) {
      var filtered = _webmidi2.default.outputs.filter(function (output) {
        return output.name.match(/prodipe/i);
      });
      if (filtered.length) {
        // midiDevice = filtered[0]
      }
    }
    // midiDevice = midiDevice || WebMidi.outputs[0]
    // console.log(midiDevice.name)
  }
}

/* play a single note */

function play_note(index, duration) {
  var channel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "all";
  var exporting = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var defer = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;

  // console.log(index)
  var scale = _scales2.default.current();
  var freq = scale.index(index + Math.round(_ui.nx.offset.value), _ui.nx.octave.value);
  var midi_note = (0, _util.ftom)(freq);
  var cents = midi_note % 1;
  if (cents > 0.5) {
    midi_note += 1;
    cents -= 1;
  }
  cents *= 2;
  midi_note = Math.floor(midi_note);
  if ((midiDevice || exporting) && midi_note > 127) return 0;
  var note = _tone2.default.Frequency(Math.floor(midi_note), "midi").toNote();
  var defer_time = 30000 / _tone2.default.Transport.bpm.value * defer / 128;
  if (exporting) {
    return note;
  }
  // console.log('defer', defer, defer_time)
  if (midiDevice) {
    duration = duration || 60000 / _tone2.default.Transport.bpm.value;
    if (!exporting) {
      if (defer) {
        setTimeout(function () {
          play_midi_note(note, cents, channel, duration);
        }, defer);
      } else {
        play_midi_note(note, cents, channel, duration);
      }
    }
  } else if (defer) {
    setTimeout(function () {
      _kalimba2.default.play(freq);
    }, defer_time);
  } else {
    _kalimba2.default.play(freq);
  }
  return note;
}

function play_midi_note(note, cents, channel, duration) {
  midiDevice.playNote(note, channel, { duration: duration });
  if (sendPitchBend) {
    midiDevice.sendPitchBend(cents, channel);
  }
}

/* play the next note in sequence */

function play_sequence(i, bounds, diff, note_time) {
  var channel = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "all";
  var exporting = arguments[5];
  var rows = bounds.rows,
      min = bounds.min,
      max = bounds.max;

  var count = rows.length * rows[0].length;
  if (i >= count) i = 0;
  var y = Math.floor(i / rows[0].length);
  var x = i % rows[0].length;
  // if (!x) console.log(y)
  var n = rows[y][x];
  i += 1;
  if (i >= count) i = 0;
  var midi_note = play_note((0, _util.norm)(n, min, max) * _ui.nx.multiply.value, note_time, channel, exporting);
  return [i, [midi_note], [128]];
}
// [next_i, notes, timings, pedal_note]

/* play the next row as an interval */

function play_interval_sequence(i, bounds, diff, note_time) {
  var channel = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "all";
  var exporting = arguments[5];
  var rows = bounds.rows,
      min = bounds.min,
      max = bounds.max;

  var count = rows.length;
  if (i >= count) i = 0;
  var y = i % count;
  var row = rows[y];
  if (!row) {
    i = 0;return;
  }
  var row_min = Math.min.apply(Math, row);
  // const row_max = Math.max.apply(Math, row)
  var row_f0 = (0, _util.norm)(row_min, min, max);
  var row_root = row_f0 * _ui.nx.multiply.value;
  var notes = row.map(function (n) {
    var note = row_root + (0, _util.norm)(n - row_min, diff.min, diff.max) * _ui.nx.interval.value;
    play_note(note, note_time, channel, exporting);
  });
  i += 1;
  return [i, notes];
}

/* generate a 1-track midi file by calling the play function repeatedly */

function export_pattern_as_midi(dataset, bounds, diff, tempo, timingIndex, play_fn, max_i) {
  // const behavior = document.querySelector('#behavior').value
  var rows = bounds.rows;
  // let count = behavior === 'sequence' ? rows[0].length * rows.length : rows.length

  max_i = max_i || rows[0].length;
  var notes = void 0,
      timings = void 0;
  var note_time = void 0;
  // let timing = note_values[timingIndex][2]
  var pedal_note = void 0,
      pedal_track = void 0,
      next_i = void 0;
  var wait = 0;
  var midi_track = new MidiWriter.Track();
  midi_track.setTempo(tempo);
  if (dataset.pedal) {
    pedal_track = new MidiWriter.Track();
    pedal_track.setTempo(tempo);
  }
  for (var i = 0, len = max_i; i < len; i++) {
    // if (timing.length) {
    //   note_time = timing[i % timing.length]
    // } else {
    //   note_time = timing
    // }
    // midi_track.addEvent(new MidiWriter.NoteEvent({ pitch: notes, duration: 't' + note_time }))
    // console.log(i, notes, timings)
    var _play_fn = play_fn(i, bounds, diff, note_time, "all", true);

    var _play_fn2 = (0, _slicedToArray3.default)(_play_fn, 4);

    next_i = _play_fn2[0];
    notes = _play_fn2[1];
    timings = _play_fn2[2];
    pedal_note = _play_fn2[3];
    if (!notes.length) wait += 128;
    for (var j = 0; j < notes.length; j++) {
      console.log(i, j, notes[j], timings[j], wait, pedal_note);
      var e = {
        pitch: notes[j],
        duration: 't' + timings[j],
        velocity: 50
      };
      if (wait) {
        e.wait = 't' + wait;
      }
      midi_track.addEvent(new MidiWriter.NoteEvent(e));
      wait = 0;
    }
    if (dataset.pedal) {
      pedal_track.addEvent(new MidiWriter.NoteEvent({
        pitch: pedal_note,
        duration: 't128',
        velocity: 25
      }));
    }
  }
  var tracks = dataset.pedal ? [midi_track, pedal_track] : [midi_track];
  var writer = new MidiWriter.Writer(tracks);
  var blob = (0, _util.dataURItoBlob)(writer.dataUri());
  (0, _FileSaver.saveAs)(blob, 'Recording - ' + dataset.name + '.mid');
}


//////////////////
// WEBPACK FOOTER
// ./client/lib/midi.js
// module id = 120
// module chunks = 0